import { CLUSTER_X_ID, CLUSTER_Y_ID } from '../../constants/cluster-ids'

const clusterSelectors = {
    all: state => state.assignment.clusters,
    groupX: state => clusterSelectors.all(state)?.find(cluster => cluster.cluster_id === CLUSTER_X_ID),
    groupY: state => clusterSelectors.all(state)?.find(cluster => cluster.cluster_id === CLUSTER_Y_ID),
}

export default clusterSelectors
